import React, { useContext } from 'react';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { Link } from 'react-router-dom';
import { H4, P } from '../../AbstractElements';
import { Imagedesc, PortfolioTitle } from '../../Constant';
import GalleryContext from '../../Context/Gallery';

const GalleryImageDesc = () => {
  const { smallImages } = useContext(GalleryContext);
  return (
    <Gallery>
      {smallImages &&
        smallImages.map((item, index) => {
          return (
            <figure key={index} className='col-xl-3 col-sm-6 box-col-25'>
              <Item original={require(`../../assets/images/${item}`)} width='1024' height='768' caption='hello'>
                {({ ref, open }) => (
                  <Link onClick={open}>
                    <img className='img-thumbnail' ref={ref} src={require(`../../assets/images/${item}`)} alt='' />
                    <div className='caption'>
                      <H4>{PortfolioTitle}</H4>
                      <P>{Imagedesc}</P>
                    </div>
                  </Link>
                )}
              </Item>
            </figure>
          );
        })}
    </Gallery>
  );
};

export default GalleryImageDesc;
